import { render } from "./SvgLocation.vue?vue&type=template&id=5a65e0fe"
const script = {}

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__